import { configureStore, combineReducers, Reducer } from '@reduxjs/toolkit'

interface IRootState {}

const rootReducer: Reducer<IRootState> = combineReducers({}) as Reducer<IRootState>

export function createStore(reduxState?: any) {
  return configureStore({
    reducer: rootReducer,
    preloadedState: reduxState,
  })
}

type AppStore = ReturnType<typeof createStore>

export type AppState = ReturnType<AppStore['getState']>
